import {Type} from '@angular/core';
import {AlertType} from '../common/enums/alert.enum';

export interface IAlertButton {
  title: string;
  className?: AlertButtonClass;
  value: boolean | string;
  disabled?: boolean;
  type: AlertButtonType;
}

export interface IAlertButtonSeparator {
  type: AlertButtonType.SEPARATOR;
}

export interface IAlertContext {
  title: string;
  description?: string;
  descriptionComponent?: Type<unknown>;
  data?: unknown;
}

export type AlertResult = boolean | string | undefined;

export interface IPopupAlert {
  id: string;
  title: string;
  description?: string;
  descriptionComponent?: Type<unknown>;
  data: unknown;
  buttons: (IAlertButton | IAlertButtonSeparator)[];
  type: AlertType;
}

export enum AlertDialogCustomResponse {
  SAVE = 'SAVE',
  DELETE = 'DELETE',
  CANCEL = 'CANCEL',
  SKIP = 'SKIP',
}

export enum AlertButtonType {
  FLAT = 'flat',
  STROKED = 'stroked',
  SEPARATOR = 'separator',
}

export enum AlertButtonClass {
  PRIMARY = 'mat-primary',
  ACCENT = 'mat-accent',
  WARN = 'mat-warn',
  DANGER = 'mat-danger',
  GRAY = 'mat-gray',
  BUTTON_DANGER = 'mat-button--danger',
}
